<template>
	<div class="HelpResources" v-show="currentTab">
		<div class="d-sr-only-focusable float-right text-decoration-underline" tabindex="0" @keyup.enter="focusToTop" @click="focusToTop" ref="firstFocusable" role="link">Go to top of page</div>
		<h2>Resources</h2>
		<v-container>
			<v-row no-gutters>
				<!-- Loop through our computed property for the displayable columns -->
				<v-col
					class="left-align"
					v-for="(column, columnIndex) in getLinkColumns"
					:key="columnIndex"
				>
					<h2>{{column.header}}</h2>
					<ul>
						<li
							v-for="(item, i) in column.links"
							:key="i"
						>
						<a
								v-if="item.url && item.url !== '' && item.download"
								:href="item.url"
								download
								:aria-label="item.text + ' - Download'"
							>
								<span v-html="item.text"></span>
							</a>
							<a
								v-else-if="item.url && item.url !== ''"
								:href="item.url"
								target="_blank"
								:aria-label="item.text + ' - New Window'"
							>
								<span v-html="item.text"></span>
							</a>
							<span v-else v-html="item.text"></span>
							<span class="linkDetails" v-html="item.details"></span>
							<ul v-if="item.children && item.children.length > 0">
								<li
									v-for="(childItem, childIndex) in item.children"
									:key="childIndex"
								>
									<span v-html="childItem.text"></span>
								</li>
							</ul>
						</li>
					</ul>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';

export default {
	name: 'HelpResources',
	props: {
	},
	data: () => ({
		// kept links there commented out so they aren't lost
		instructionLinks: [
			{
				text: 'Researcher Site Quick User Guide [pdf]',
				url: './QuickUserGuide-ASA24-ResearcherSite-FINAL.pdf',
				download: true
			},
			{
				text: 'About ASA24 [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/About-ASA24.pdf'
				url: './About-ASA24.pdf',
				download: true
			},
			{
				text: 'ASA24 Researcher Agreement [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/ASA24-ResearcherAgreement.pdf'
				url: './ASA24-ResearcherAgreement.pdf',
				download: true
			},
			{
				text: 'Key Considerations for Researchers [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/KeyConsiderationsForResearchers.pdf'
				url: './KeyConsiderationsForResearchers.pdf',
				download: true
			},
			{
				text: 'System Requirements',
				url: 'https://epi.grants.cancer.gov/asa24/resources/system-requirements.html',
				details: ''
			},
			{
				text: 'Key Terms [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/KeyTerms.pdf'
				url: './KeyTerms.pdf',
				download: true
			},
			{
				text: 'Tips for Managing Studies [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/TipsforManagingStudiesUsing-ASA24.pdf',
				url: './TipsforManagingStudiesUsing-ASA24.pdf',
				download: true
			},
			{
				text: 'Managing Respondent Accounts [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/ManagingRespondentAccounts.pdf'
				url: './ManagingRespondentAccounts.pdf',
				download: true
			},
			{
				text: 'Detailed Information for Completeing the Import File [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/DetailedInformationForCompletingTheImportFile.pdf'
				url: './DetailedInformationForCompletingTheImportFile.pdf',
				download: true
			},
			{
				text: 'Provide Study Staff Access to ASA24 [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/ProvideStudyStaffAccess-to-ASA24.pdf'
				url: './ProvideStudyStaffAccess-to-ASA24.pdf',
				download: true
			},
			{
				text: 'Nutrients and Food Groups Included in ASA24 Analysis Reports [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/NutrientsAndFoodGroupsIncluded-in-ASA24.pdf'
				url: './NutrientsAndFoodGroupsIncluded-in-ASA24.pdf',
				download: true
			},
			{
				text: 'Resources Related to the Healthy Eating Index (HEI)',
				url: 'https://epi.grants.cancer.gov/asa24/resources/hei.html'
			},
			{
				text: 'Data Dictionaries for Analysis Files',
				url: 'https://epi.grants.cancer.gov/asa24/researcher/sample.html'
			},
			{
				text: 'ASA24 Modules [pdf]',
				// url: 'file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/Modules.pdf',
				url: './Modules.pdf',
				download: true,
				children: [
					{
						text: 'Location'
					},
					{
						text: 'Source'
					},
					{
						text: 'TV/Computer Use'
					},
					{
						text: 'Supplement'
					},
					{
						text: 'Respondent Nutrition Report'
					},
					{
						text: 'Sleep'
					}
				]
			}
		],
		helpLinks: [
			{
				text: 'NCI ASA24 Website',
				url: 'https://epi.grants.cancer.gov/asa24/',
				details: 'Includes background information, downloadable resources for study participants and staff, descriptions of the different versions of ASA24, and FAQs'
			},
			{
				text: 'ASA24 Help for Respondents',
				url: 'https://epi.grants.cancer.gov/asa24/resources/instructions.html'
			},
			{
				text: 'ASA24 Respondent Website',
				url: utilityService.getLoginUrl(false)
			},
			{
				text: 'Register a Study and Best Practices for Using ASA24',
				url: 'https://epi.grants.cancer.gov/asa24/register/'
			},
			{
				text: 'Known Issues and Workarounds',
				url: 'https://epi.grants.cancer.gov/asa24/resources/issues.html'
			},
			{
				text: 'ASA24 Listserv',
				url: 'https://list.nih.gov/cgi-bin/wa.exe?A0=ASA24-L',
				details: 'Allows potential/current users to communicate with the ASA24 team and other users'
			},
			{
				text: 'Overview Webinar for ASA24 (November 2022)',
				url: 'https://nci.rev.vbrick.com/sharevideo/fdacd19b-9383-4b3c-b6e9-1bd26979f1d7?startAt=01m01s'
			},
			{
				text: 'ASA24-2020 Retirement & Tips for Transitioning to ASA24-2022 (August 2023)',
				url: 'https://secure-web.cisco.com/1356WVCvxCEnP6FROB_cRf5kf37KcS7imS1X-bQMr6MtBFXQmRYyEpqluG-nf99sKqDTiuB7_-HlYU7439COJcWY7OjXstdTKMYePz3QYmCekbOd-hh8Jt8nFXPQ8t7PRdHwL1jJ-nNM96fYLcQ-iEDH5J24WMbi6yhUc3zA-6kpvXSxJ86EqHJjCTV6t1RTAeLm-u9e3y4CC9vOB_rn-27tnw13SfkLZhQKyYlenTac2gilANPp8wIRsgQ_Rx9PN/https%3A%2F%2Fnci.rev.vbrick.com%2Fsharevideo%2Fde9c1158-587a-40b8-9f1f-e831a48cee9c'
			},
			{
				text: 'Setting up Scheduled Studies and Optional Study Modules (November 2023)',
				url: 'https://nci.rev.vbrick.com/#/videos/1f47c0ee-1d6b-43f7-acc8-60f40d2e9922'
			}
		]
	}),
	mounted () {
	},
	methods: {
		async checkTabMatch ({ tabIndex, subTabIndex } = {}) {
			const me = this
			const tabsPos = await utilityService.getTabsPositionByName('Help & Resources', this.$studyTabConfig);
			if (tabsPos.tabPos === tabIndex) {
				var myFirstElement = me.$refs.firstFocusable
				setTimeout(() => {
					myFirstElement.focus();
				}, '350');
			}
		},
		focusToTop () {
			var myHeader = document.getElementById('skipToMain')
			myHeader.focus()
		}
	},
	computed: {
		getLinkColumns () {
			return [
				{
					header: 'Researcher Website Instructions',
					links: this.instructionLinks
				},
				{
					header: 'Helpful Links',
					links: this.helpLinks
				}
			];
		},
		currentTab () {
			const tabPosition = {
				tabIndex: parseInt(this.$store.getters.getCurrentStudyTabIndex),
				subTabIndex: parseInt(this.$store.getters.getCurrentStudySubTabIndex)
			};

			this.checkTabMatch(tabPosition);

			return tabPosition;
		}
	}
}
</script>

<style>
.linkDetails {
	font-style: italic;
	margin-left: 5px;
}
</style>
